import { useState, useEffect } from "react";
import Header from "../../../componente/header";
import "./style.css";
import api from "../../../services/api";
import Modal from "react-modal";
import { IMaskInput } from "react-imask";
import PopUp from "../../../componente/popup";
import PopUpMotivoExclusao from "../../../componente/popup";
import { podeInserir, podeEditar, podeExcluir } from "../../../componente/permissoes";

function CadFornecedor() {
  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);

  const [edtcodfornecedor, setedtcodfornecedor] = useState(0);
  const [edttipofornecedor, setedttipofornecedor] = useState("");
  const [edtrazaosocial, setedtrazaosocial] = useState("");
  const [edtnomefantasia, setedtnomefantasia] = useState("");
  const [edtcnpj, setedtcnpj] = useState("");
  const [edtnome, setedtnome] = useState("");
  const [edtcpf, setedtcpf] = useState("");
  const [edtcep, setedtcep] = useState("");
  const [edtendereco, setedtendereco] = useState("");
  const [edtnumero, setedtnumero] = useState("");
  const [edtcomplemento, setedtcomplemento] = useState("");
  const [edtbairro, setedtbairro] = useState("");
  const [edtcidade, setedtcidade] = useState("");
  const [edttelefone, setedttelefone] = useState("");
  const [edtwhatsapp, setedtwhatsapp] = useState("");
  const [edtproprietario, setedtproprietario] = useState("");
  const [edtdtcadastro, setedtdtcadastro] = useState("");
  const [edtativo, setedtativo] = useState("");

  const [novo, setnovo] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenMotivoExclusao, setIsOpenMotivoExclusao] = useState(false);
  const [edtMotivo, setEdtMotivo] = useState("");

  const handleOpen = (cad) => {
    setedtcodfornecedor(cad.codfornecedor);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    setEdtMotivo("");
    setIsOpenMotivoExclusao(true);
  };

  const handleInformarMotivoExclusao = () => {
    if (edtMotivo !== "") {
      Excluir();
      setIsOpenMotivoExclusao(false);
      ListarFornecedor();
    } else {
      alert("Descreva o motivo antes de informar");
    }
  };

  const handleCloseMotivoExclusao = () => {
    setIsOpenMotivoExclusao(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  function ListarFornecedor() {
    api
      .get("v1/cadastro/fornecedor", {
        params: {
          busca: abusca,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Cadastrar() {
    api
      .post(
        "v1/cadastro/fornecedor",
        {
          tipofornecedor: edttipofornecedor,
          razaosocial: edtrazaosocial,
          nomefantasia: edtnomefantasia,
          cnpj: edtcnpj,
          nome: edtnome,
          cpf: edtcpf,
          cep: edtcep,
          endereco: edtendereco,
          numero: edtnumero,
          complemento: edtcomplemento,
          bairro: edtbairro,
          cidade: edtcidade,
          telefone: edttelefone,
          whatsapp: edtwhatsapp,
          proprietario: edtproprietario,
          dtcadastro: edtdtcadastro,
          ativo: edtativo,
          codusuario: localStorage.getItem("tempCodUsuario"),
          excluido: "N",
          codempresa: 1,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        setabusca("a");
        setabusca("");
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/fornecedor",
        {
          codfornecedor: edtcodfornecedor,
          tipofornecedor: edttipofornecedor,
          razaosocial: edtrazaosocial,
          nomefantasia: edtnomefantasia,
          cnpj: edtcnpj,
          nome: edtnome,
          cpf: edtcpf,
          cep: edtcep,
          endereco: edtendereco,
          numero: edtnumero,
          complemento: edtcomplemento,
          bairro: edtbairro,
          cidade: edtcidade,
          telefone: edttelefone,
          whatsapp: edtwhatsapp,
          proprietario: edtproprietario,
          dtcadastro: edtdtcadastro,
          codusuario: localStorage.getItem("tempCodUsuario"),
          ativo: edtativo,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        ListarFornecedor();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/fornecedor", {
        params: {
          codfornecedor: edtcodfornecedor,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        ListarFornecedor();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
    setshowform(false);
  }

  function ExcluirCad(cad) {
    setedtcodfornecedor(cad.codfornecedor);
    Excluir();
  }

  useEffect(() => {
    ListarFornecedor();
  }, [abusca, showform, handleConfirma]);

  function closeModal() {
    setshowform(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodfornecedor(0);
    setedttipofornecedor("J");
    setedtrazaosocial("");
    setedtnomefantasia("");
    setedtcnpj("");
    setedtnome("");
    setedtcpf("");
    setedtcep("");
    setedtendereco("");
    setedtnumero("");
    setedtcomplemento("");
    setedtbairro("");
    setedtcidade("");
    setedttelefone("");
    setedtwhatsapp("");
    setedtproprietario("");

    const dt = new Date();
    const date =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt.getDate().toString().padStart(2, "0");
    let time =
      dt.getHours().toString().padStart(2, "0") +
      ":" +
      dt.getMinutes().toString().padStart(2, "0");
    let dtcadastro = date + "T" + time;

    setedtdtcadastro(dtcadastro);
    setedtativo("S");
  }

  function openModalEditar(props) {
    setshowform(true);
    setnovo(false);

    setedtcodfornecedor(props.codfornecedor);
    setedttipofornecedor(props.tipofornecedor);
    setedtrazaosocial(props.razaosocial);
    setedtnomefantasia(props.nomefantasia);
    setedtcnpj(props.cnpj);
    setedtnome(props.nome);
    setedtcpf(props.cpf);
    setedtcep(props.cep);
    setedtendereco(props.endereco);
    setedtnumero(props.numero);
    setedtcomplemento(props.complemento);
    setedtbairro(props.bairro);
    setedtcidade(props.cidade);
    setedttelefone(props.telefone);
    setedtwhatsapp(props.whatsapp);
    setedtproprietario(props.proprietario);

    const dt = new Date(props.dtcadastro);
    const date =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt.getDate().toString().padStart(2, "0");
    let time =
      dt.getHours().toString().padStart(2, "0") +
      ":" +
      dt.getMinutes().toString().padStart(2, "0");
    let dtcadastro = date + "T" + time;

    setedtdtcadastro(dtcadastro);
    setedtativo(props.ativo);
  }  

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div>
        <div>
            <PopUp isOpen={isOpen} onClose={handleClose}>
              <h2>Verificação</h2>
              <p>Tem certeza que deseja excluir esse registro?</p>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleConfirma}
                  >
                    Sim
                  </button>
                  <button className="btn btn-danger" onClick={handleClose}>
                    Não
                  </button>
                </div>
              </div>
            </PopUp>
          </div>

          <div>
            <PopUpMotivoExclusao isOpen={isOpenMotivoExclusao} onClose={handleCloseMotivoExclusao}>
              <h2>Antes de Excluir</h2>
              <p>Informe qual o motivo da exclusão?</p>

              <div className="col-sm-12">
                <label htmlFor="motivo" className="form-label">
                  Motivo
                </label>
                <input
                  type="text"
                  id="motivo"
                  className="form-control"
                  placeholder="Descreva aqui"
                  value={edtMotivo}
                  onChange={(e) => setEdtMotivo(e.target.value)}
                />
              </div>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleInformarMotivoExclusao}
                  >
                    Informar
                  </button>
                  <button className="btn btn-danger" onClick={handleCloseMotivoExclusao}>
                    Cancelar
                  </button>
                </div>
              </div>
            </PopUpMotivoExclusao>
          </div>

          <Modal
            isOpen={showform}
            onRequestClose={closeModal}
            overlayClassName="modal-overlay"
            className="modal-content modal-xl"
          >
            <div className="container-fluid h-100">
              <div className="modal-header">
                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
              </div>              

              <div className="modal-body">
                <form>
                  <div className="row col-sm-12">
                    <div className="col-sm-4">
                      <div>
                        <label htmlFor="tipofornecedor" className="form-label">
                          Tipo de Fornecedor
                        </label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tipofornecedor"
                            id="tipofornecedor1"
                            value="J"
                            onChange={(e) => setedttipofornecedor(e.target.value)}
                            checked={edttipofornecedor === "J"}
                          />
                          <label
                            className="form-check-label"
                            for="inlineRadio1"
                          >
                            Pessoa Jurídica
                          </label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tipofornecedor"
                            id="tipofornecedor2"
                            value="F"
                            onChange={(e) => setedttipofornecedor(e.target.value)}
                            checked={edttipofornecedor === "F"}
                          />
                          <label className="form-check-label">
                            Pessoa Física
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
       
                  <div className="row col-sm-12">
                    <div className="col-sm-5">
                      <label htmlFor="razaosocial" className="form-label">
                        Razão Social
                      </label>
                      <input
                        type="text"
                        id="razaosocial"
                        className="form-control"
                        placeholder="Razão Social"
                        value={edtrazaosocial}
                        onChange={(e) => setedtrazaosocial(e.target.value)}
                        disabled={edttipofornecedor === 'F'}
                      />
                    </div>

                    <div className="col-sm-4">
                      <label htmlFor="nomefantasia" className="form-label">
                        Nome Fantasia
                      </label>
                      <input
                        type="text"
                        id="nomefantasia"
                        className="form-control"
                        placeholder="Nome Fantasia"
                        value={edtnomefantasia}
                        onChange={(e) => setedtnomefantasia(e.target.value)}
                        disabled={edttipofornecedor === 'F'}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="cnpj" className="form-label">
                        CNPJ
                      </label>
                      <IMaskInput 
                      mask={"00.000.000/0000-00"}
                      radix="."                      
                      id="cnpj"
                      className="form-control"
                      placeholder="CNPJ"
                      value={edtcnpj}
                      onAccept={(value) => setedtcnpj(value)}
                      disabled={edttipofornecedor === 'F'}/>
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-5">
                      <label htmlFor="nome" className="form-label">
                        Nome
                      </label>
                      <input
                        type="text"
                        id="nome"
                        className="form-control"
                        placeholder="Nome"
                        value={edtnome}
                        onChange={(e) => setedtnome(e.target.value)}
                        disabled={edttipofornecedor === 'J'}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="cpf" className="form-label">
                        CPF
                      </label>
                      <IMaskInput 
                      mask={"000.000.000-00"}
                      radix="."                      
                      id="cpf"
                      className="form-control"
                      placeholder="CPF"
                      value={edtcpf}
                      onAccept={(value) => setedtcpf(value)}
                      disabled={edttipofornecedor === 'J'}/>
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-3">
                      <label htmlFor="cep" className="form-label">
                        CEP
                      </label>
                      <IMaskInput 
                      mask={"00000-000"}
                      radix="."                      
                      id="cep"
                      className="form-control"
                      placeholder="CEP"
                      value={edtcep}
                      onAccept={(value) => setedtcep(value)}/>
                    </div>

                    <div className="col-sm-6">
                      <label htmlFor="endereco" className="form-label">
                        Endereço
                      </label>
                      <input
                        type="text"
                        id="endereco"
                        className="form-control"
                        placeholder="Endereço"
                        value={edtendereco}
                        onChange={(e) => setedtendereco(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="numero" className="form-label">
                        Número
                      </label>
                      <input
                        type="text"
                        id="numero"
                        className="form-control"
                        placeholder="Número"
                        value={edtnumero}
                        onChange={(e) => setedtnumero(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-4">
                      <label htmlFor="complemento" className="form-label">
                        Complemento
                      </label>
                      <input
                        type="text"
                        id="complemento"
                        className="form-control"
                        placeholder="Complemento"
                        value={edtcomplemento}
                        onChange={(e) => setedtcomplemento(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-4">
                      <label htmlFor="bairro" className="form-label">
                        Bairro
                      </label>
                      <input
                        type="text"
                        id="bairro"
                        className="form-control"
                        placeholder="Bairro"
                        value={edtbairro}
                        onChange={(e) => setedtbairro(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-4">
                      <label htmlFor="cidade" className="form-label">
                        Cidade
                      </label>
                      <input
                        type="text"
                        id="cidade"
                        className="form-control"
                        placeholder="Cidade"
                        value={edtcidade}
                        onChange={(e) => setedtcidade(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-3">
                      <label htmlFor="Telefone" className="form-label">
                        Telefone
                      </label>
                      <IMaskInput 
                      mask={"(00) 0 0000-0000"}
                      radix="."                      
                      id="telefone"
                      className="form-control"
                      placeholder="Telefone"
                      value={edttelefone}
                      onAccept={(value) => setedttelefone(value)}/>
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="whatsapp" className="form-label">
                        WhatsApp
                      </label>
                      <IMaskInput 
                      mask={"(00) 0 0000-0000"}
                      radix="."                      
                      id="whatsapp"
                      className="form-control"
                      placeholder="WhatsApp"
                      value={edtwhatsapp}
                      onAccept={(value) => setedtwhatsapp(value)}/>
                    </div>

                    <div className="col-sm-6">
                      <label htmlFor="proprietario" className="form-label">
                        Proprietário
                      </label>
                      <input
                        type="text"
                        id="proprietario"
                        className="form-control"
                        placeholder="Proprietário"
                        value={edtproprietario}
                        onChange={(e) => setedtproprietario(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-3">
                      <label htmlFor="dtcadastro" className="form-label">
                        Dt. Cadastro
                      </label>
                      <input
                        type="datetime-local"
                        id="dtcadastro"
                        className="form-control"
                        placeholder="dtcadastro"
                        value={edtdtcadastro}
                        onChange={(e) => setedtdtcadastro(e.target.value)}
                        disabled
                      />
                    </div>

                    <div className="col-sm-4">
                      <div>
                        <label htmlFor="ativo1" className="form-label">
                          Ativo
                        </label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="S"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "S"}
                          />
                          <label
                            className="form-check-label"
                            for="inlineRadio1"
                          >
                            Sim
                          </label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="N"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "N"}
                          />
                          <label className="form-check-label">Não</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div className="modal-footer">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button className="btn btn-danger ms-4" onClick={closeModal}>
                    Cancelar
                  </button>
                  <button className="btn btn-success ms-4" onClick={Salvar}>
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>

        <div className="row">
          <h1 className="ms-4">Cadastro de Fornecedor</h1>
          <p className="ms-4">
            Rotina para cadastrar todos os fornecedores da empresa.
          </p>
          <hr />
        </div>

        <div className="row">
          <div className="col-10">
            <label className="d-block" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código, razão social, nome fantasia, cnpj, nome ou cpf"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => setabusca(e.target.value)}
            />
          </div>
          <div className="col-2 d-flex justify-content-center">
            <button
              className="btn btn-success btnnovo"
              onClick={() => openModalNovo()}
              disabled={!podeInserir("/cadastro/fornecedor")}
            >
              Novo
            </button>
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row tabela">
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="codigo">Código</th>
                <th className="razao">Razão Social/Nome</th>
                <th className="cnpj">Documento</th>
                <th className="razao">Proprietário</th>
                <th className="acao">Ações</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(function (item) {
                return (
                  <tr key={item.codfornecedor}>
                    <th>{item.codfornecedor}</th>
                    <th>{item.razaonome}</th>
                    <th>{item.documento}</th>
                    <th>{item.proprietario}</th>
                    <th>
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn fa-regular fa-pen-to-square"
                          onClick={() => openModalEditar(item)}
                          disabled={!podeEditar("/cadastro/fornecedor")}
                        ></button>
                        <button
                          className="btn fa-solid fa-trash"
                          onClick={() => handleOpen(item)}
                          disabled={!podeExcluir("/cadastro/fornecedor")}
                        ></button>
                      </div>
                    </th>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={5}>Quantidade de Registros: {lista.length}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
}

export default CadFornecedor;
